/* assets/free-sample.js
   One merged sample line per sample variant.
   Sample qty = number of DIFFERENT normal products in the cart that point to that sample.
   - product form carries hidden property _free_sample_variant (set in free-sample-picker.liquid)
   - remove a product -> sample qty drops; no products left -> sample removed
   - sample lines added any other way are removed */
(function () {
  const nativeFetch = window.fetch.bind(window);
  if (window.__freeSampleInit) return;
  window.__freeSampleInit = true;

  const FLAG = '_free_sample';
  const VAR = '_free_sample_variant';
  const IDS = () => (window.FREE_SAMPLE_IDS || []).map(String);
  const hasFlag = (i) => i.properties && i.properties[FLAG] === 'true';
  const isSample = (i) => IDS().includes(String(i.variant_id)) || hasFlag(i);

  const getCart = () => nativeFetch('/cart.js').then((r) => r.json());
  const post = (url, body) =>
    nativeFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

  // product id -> sample variant id (remembered when the product is added from its page)
  const loadMap = () => { try { return JSON.parse(localStorage.getItem('fsMap') || '{}'); } catch (e) { return {}; } };
  const saveMap = (pid, vid) => { try { const m = loadMap(); m[String(pid)] = String(vid); localStorage.setItem('fsMap', JSON.stringify(m)); } catch (e) {} };

  let busy = false;
  let cleaning = false;

  // variantId -> Set(product ids) that want this sample
  function wanted(cart) {
    const map = new Map();
    cart.items.forEach((i) => {
      if (isSample(i)) return;
      const v = (i.properties && i.properties[VAR]) || loadMap()[String(i.product_id)];
      if (!v) return;
      if (!map.has(String(v))) map.set(String(v), new Set());
      map.get(String(v)).add(String(i.product_id));
    });
    return map;
  }

  // ---- before the theme adds the main product: set sample qty
  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;
      if (!form.matches || !form.matches('form.js-product-form')) return;
      if (form.dataset.freeSampleBusy === '1') return;

      const marker = form.querySelector('[data-free-sample-auto]');
      if (!marker) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      form.dataset.freeSampleBusy = '1';
      busy = true;
      try {
        const V = String(marker.dataset.variantId);
        const P = String(marker.dataset.parentId);
        saveMap(P, V);
        const cart = await getCart();
        const parents = wanted(cart).get(V) || new Set();
        parents.add(P);
        const want = parents.size;
        const line = cart.items.find((i) => isSample(i) && String(i.variant_id) === V);
        if (line) {
          if (line.quantity !== want) await post('/cart/change.js', { id: line.key, quantity: want });
        } else {
          await post('/cart/add.js', {
            items: [{ id: Number(V), quantity: want, properties: { [FLAG]: 'true' } }],
          });
        }
      } catch (err) { console.error('Free sample failed', err); }

      form.requestSubmit(e.submitter || undefined);
      setTimeout(() => { delete form.dataset.freeSampleBusy; busy = false; cleanup(); }, 3500);
    },
    true
  );


  // ---- in-place drawer refresh (keeps drawer open) -------------------------
  const CHECKOUT_SEL = 'button[name="checkout"],input[name="checkout"],a[href$="/checkout"]';
  const KEEP_ATTR = /^(class|style|aria-hidden|inert|open|tabindex)$/;
  const SKIP_NODE = /^(SCRIPT|STYLE|TEMPLATE|NOSCRIPT)$/;

  function sync(live, fresh) {
    if (live.nodeType !== 1) {
      if (live.nodeValue !== fresh.nodeValue) live.nodeValue = fresh.nodeValue;
      return;
    }
    Array.from(live.attributes).forEach((a) => {
      if (!KEEP_ATTR.test(a.name) && !fresh.hasAttribute(a.name)) live.removeAttribute(a.name);
    });
    Array.from(fresh.attributes).forEach((a) => {
      if (!KEEP_ATTR.test(a.name) && live.getAttribute(a.name) !== a.value) live.setAttribute(a.name, a.value);
    });
    if (live.tagName === 'INPUT' && !/^(checkbox|radio)$/.test(live.type)) {
      live.value = fresh.getAttribute('value') || '';
    }
    const lk = Array.from(live.childNodes);
    const fk = Array.from(fresh.childNodes);
    fk.forEach((f, i) => {
      const l = lk[i];
      if (SKIP_NODE.test(f.nodeName)) return;
      if (!l) { live.appendChild(document.importNode(f, true)); return; }
      if (l.nodeType !== f.nodeType || l.nodeName !== f.nodeName) {
        live.replaceChild(document.importNode(f, true), l);
        return;
      }
      sync(l, f);
    });
    for (let i = lk.length - 1; i >= fk.length; i--) live.removeChild(lk[i]);
  }

  async function redraw() {
    try {
      const cart = await getCart();
      const btn = document.querySelector(CHECKOUT_SEL);
      if (!btn) return false;
      const html = await (await nativeFetch(location.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const chain = [];
      for (let n = btn.parentElement; n && n !== document.body; n = n.parentElement) chain.push(n);
      chain.reverse(); // outermost first

      let root = null, fresh = null;
      for (const n of chain) {
        if (n.id && /cart|drawer|bag/i.test(n.id)) {
          const f = doc.getElementById(n.id);
          if (f) { root = n; fresh = f; break; }
        }
      }
      if (!root) {
        for (const n of chain) {
          if (n.tagName.indexOf('-') > -1 && /cart|drawer/i.test(n.tagName)) {
            const f = doc.querySelector(n.tagName.toLowerCase());
            if (f) { root = n; fresh = f; break; }
          }
        }
      }
      if (!root) return false;
      // safety: the fetched drawer must really contain the current cart
      if (cart.item_count > 0 && !fresh.querySelector(CHECKOUT_SEL)) return false;
      if (!cart.items.every((i) => fresh.textContent.indexOf(i.product_title) > -1)) return false;

      sync(root, fresh);
      document.dispatchEvent(new CustomEvent('free-sample:redrawn'));
      return true;
    } catch (e) { return false; }
  }

  // ---- keep sample quantities in sync with the products in the cart
  async function cleanup(opts) {
    const silent = !!(opts && opts.silent);
    if (cleaning || busy) return false;
    cleaning = true;
    let changed = false;
    try {
      const cart = await getCart();
      const want = wanted(cart);
      const updates = {};
      const seen = new Set();
      cart.items.filter(isSample).forEach((i) => {
        const v = String(i.variant_id);
        const qty = want.has(v) ? want.get(v).size : 0;
        if (!hasFlag(i) || seen.has(v)) updates[i.key] = 0;       // stray or duplicate line
        else { seen.add(v); if (i.quantity !== qty) updates[i.key] = qty; }
      });

      if (Object.keys(updates).length) {
        const r = await post('/cart/update.js', { updates });
        changed = r.ok;
      }
      // sample missing although a product wants it (e.g. page reload mid-add)
      for (const [v, set] of want) {
        if (!seen.has(v) && !cart.items.some((i) => isSample(i) && String(i.variant_id) === v && hasFlag(i))) {
          const r = await post('/cart/add.js', {
            items: [{ id: Number(v), quantity: set.size, properties: { [FLAG]: 'true' } }],
          });
          if (r.ok) changed = true;
        }
      }
      if (changed && !silent) {
        // 1) try to update the open drawer in place (it stays open)
        const ok = await redraw();
        // 2) fallback: reload and reopen the drawer
        if (!ok) {
          try { sessionStorage.setItem('fsReopenCart', '1'); } catch (e) {}
          setTimeout(() => location.reload(), 250);
        }
      }
    } catch (e) {}
    cleaning = false;
    return changed;
  }

  // Intercept cart writes. For change/update (e.g. removing a product in the drawer) the sample
  // is fixed BEFORE the theme gets its response, so the drawer is drawn once, with the final cart.
  window.fetch = async function (input, init) {
    const url = (typeof input === 'string' ? input : (input && input.url)) || '';
    if (!/\/cart\/(change|update|add)/.test(url)) return nativeFetch.apply(this, arguments);

    let bodyText = '';
    try {
      if (init && typeof init.body === 'string') bodyText = init.body;
      else if (init && init.body instanceof URLSearchParams) bodyText = init.body.toString();
      else if (init && init.body instanceof FormData) bodyText = new URLSearchParams(init.body).toString();
      else if (typeof Request !== 'undefined' && input instanceof Request) bodyText = await input.clone().text();
    } catch (e) {}

    const res = await nativeFetch.apply(this, arguments);
    if (busy) return res;

    if (!/\/cart\/(change|update)/.test(url)) {   // add outside our flow (e.g. quick add)
      setTimeout(cleanup, 150);
      return res;
    }

    let changed = false;
    try { changed = await cleanup({ silent: true }); } catch (e) {}
    if (!changed) return res;

    // hand the theme a response that reflects the final cart (and re-rendered sections, if it asked)
    let sections, sectionsUrl;
    try {
      const o = JSON.parse(bodyText);
      sections = o.sections; sectionsUrl = o.sections_url;
    } catch (e) {
      try { const q = new URLSearchParams(bodyText); sections = q.get('sections'); sectionsUrl = q.get('sections_url'); } catch (e2) {}
    }
    try {
      if (sections) {
        const payload = { updates: {}, sections };
        if (sectionsUrl) payload.sections_url = sectionsUrl;
        return await post('/cart/update.js', payload);
      }
      return await nativeFetch('/cart.js');
    } catch (e) { return res; }
  };

  // ---- reopen the cart drawer after our reload
  const CART_TOGGLES = [
    '[data-cart-toggle]', '[data-open-cart]', '[data-drawer-open="cart"]', '.js-cart-toggle',
    '.js-drawer-open-cart', '#cart-icon-bubble', 'button[aria-controls*="cart" i]',
    'header a[href$="/cart"]', 'a[href$="/cart"]',
  ];
  function reopenDrawer() {
    let flag = null;
    try { flag = sessionStorage.getItem('fsReopenCart'); sessionStorage.removeItem('fsReopenCart'); } catch (e) {}
    if (!flag || location.pathname.indexOf('/cart') === 0) return;
    for (const sel of CART_TOGGLES) {
      const el = document.querySelector(sel);
      if (el) { el.click(); break; }
    }
  }
  window.addEventListener('load', () => { setTimeout(reopenDrawer, 400); setTimeout(cleanup, 900); });
})();
